module.exports = __webpack_public_path__ + "img/Psychology3.2464e0a1.png";